var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-box"},[_c('BaseSubTitle',{attrs:{"title":"店铺信息"}}),_c('div',{staticStyle:{"width":"740px"}},[_c('ShopInfoForm',{attrs:{"shopId":_vm.id}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }